;(function ( $, window, document, undefined ) {
	var pluginName = "analytics",
		defaults = {
			src: '/js/nc-vendors/xtcore.js'
		};

	function Plugin( element, options ) {
			this.element = element;
			this.settings = $.extend({}, defaults, options);
			this._defaults = defaults;
			this._name = pluginName;
			this.init();
	}

	$.extend(Plugin.prototype, {

	init: function() {
		this.setVars();
		this.printPage();
		this.setEvents();
	},

	setVars: function() {
		var _this = this;
		xt_multc = "&x1=[" + escape(document.location.pathname) + "]"; // url
		if ($(".js-analytics-author").length) {
			xt_multc += "&x2=[" + this.cleanString($(".js-analytics-author").text()) + "]"; // article : auteur
		}
		if ($(".js-analytics-timestamp").length) {
			xt_multc += "&x5=" + getUSDate($(".js-analytics-timestamp").data("timestamp")).replace(/-/g, ''); // article : date de publication
			xt_multc += "&x6=[" + getUSTime($(".js-analytics-timestamp").data("timestamp")).substr(0, 5).replace(/:/g, 'h') + "]"; // article : heure de publication
		}
		if ($(".template-article").length && !$(".page-chat").length) {
			var x8 = ($(".page-newsflash").length) ? 1 : 2;
			xt_multc += "&x8=" + x8; // article : court=1, long=2
			var x9 = ($(".cover img").length) ? 1 : 2;
			xt_multc += "&x9=" + x9; // article : avec photo=1, sans photo=2
			var x10 = ($("iframe[src*='dailymotion.com'], iframe[src*='youtube.com'], iframe[src*='vimeo.com']").length) ? 1 : 2;
			xt_multc += "&x10=" + x10; // article : avec video=1, sans video=2
			var x11 = ($("iframe[src*='twitter.com'], iframe[src*='facebook.com'], iframe[src*='vine.co'], iframe[src*='instagram.com']").length) ? 1 : 2;
			xt_multc += "&x11=" + x11; // article : avec video=1, sans video=2
			var x12 = ($(".container-global").data("efr") && $(".container-global").data("efr") == 1) ? 'EFR' : 'FF';
			xt_multc += "&x12=" + x12; // article : source
		}
		if ($("[data-comments-count]").length) {
			xt_multc += "&x13=" + $("[data-comments-count]").data("comments-count"); // article : nb commentaires
		}
		if (connection.datas) {
			if (connection.datas.magAbonne)
				xt_multc += "&x14=1"; // visiteur : abonné
			else
				xt_multc += "&x14=0"; // visiteur : non abonné
			xt_multc += "&x15=1"; // visiteur : connecté
			xt_an = connection.datas.id; // user id
			xt_ac = (connection.datas.gender == 'M') ? 2 : 1; // user category
		} else {
			xt_multc += "&x14=0"; // visiteur : abonné
			xt_multc += "&x15=0"; // visiteur : connecté
		}
		if ($(".js-analytics-tag").length) {
			xt_tags = '';
			$(".js-analytics-tag").each(function() {
				if (xt_tags)
					xt_tags += "|"
				xt_tags += xt_tags = "[" + _this.cleanString($(this).text()) + "]"; // tags
			});
		}
		xt_f = '';
		if ($(".page-match").length) {
			xt_f += "&f1=[" + this.cleanString($(".js-analytics-team1").text()) +"-"+ this.cleanString($(".js-analytics-team2").text()) + "]";  // live : équipes
			xt_f += "&f2=[" + this.cleanString($(".js-analytics-compet").text()) + "]"; // live : compet
			xt_f += "&f3=[" + this.cleanString($(".js-analytics-time").text()) + "]"; // live : heure
			if ($(".js-analytics-score1, .js-analytics-score2").length == 2)
				xt_f += "&f4=[" + this.cleanString($(".js-analytics-score1").text()) +"-"+ this.cleanString($(".js-analytics-score2").text()) + "]"; // live : score
			if ($(".js-analytics-channel").length) {
				xt_f += "&f5=1"; // live : retransmission TV
				xt_f += "&f6=[" + this.cleanString($(".js-analytics-channel").text()) + "]"; // live : diffuseur TV
			} else {
				xt_f += "&f5=0"; // live : retransmission TV
			}
		}
		if ($(".page-poll").length && $("[data-poll-id]").hasClass("is-polled")) {
			xt_f += "&f1=[" + this.cleanString($("[data-poll-id] .heading").text()) + "]"; // débat : question
			xt_f += "&f2=[" + this.cleanString($("[data-poll-id] .js-poll-btn.is-active").text()) + "]"; // débat : réponse
		}
		if ($(".page-error").length) {
			xt_f += "&f1=[" + escape(document.location.pathname) + "]"; // erreur : url
			xt_f += "&f2=[" + escape(document.referrer) + "]"; // erreur : referrer
			xt_f += "&f3=[404]"; // erreur : code
		}
	},

	printPage: function(indic) {
		var self = this;

		// cmp.getCmpConsent('vendor', cmp.getKeyForVendor('at_internet')).then(function(consent) {
		// 	if (consent) {
				if (indic)
					xtpage = xtpage + "&indicateur=" + indic;
				var at = document.createElement('script');
				at.type = 'text/javascript';
				at.async = true;
				at.src = self.settings.src;
				(document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]||document.getElementsByTagName('script')[0].parentNode).insertBefore(at,null);
		// 	}
		// })
	},

	setEvents: function() {
		$(document).on("tabing-ready tabing-refresh", ".js-tabs.js-tabs-countaspage", $.proxy(function(e) {
			this.printPage(this.cleanString($(e.target).find(".js-tabs-item.is-active").text()));
		}, this));
		$(document).on("tabing-ready tabing-refresh", ".js-tabs-n2.js-tabs-countaspage", $.proxy(function(e) {
			this.printPage(this.cleanString($(e.target).find(".js-tabs-n2-item.is-active").text()));
		}, this));
		$(document).on("click", ".js-vel-button", function(e) {
			if (xt_ati)
				xt_adc(this, xt_ati);
		});
		$(document).on("click", "[data-share]", function(e) {
			var indic = $(this).data("share");
			if ($(e.currentTarget).parents(".js-textsharing").length)
				indic += "Intext";
			xt_med('C', xtn2, xtpage+"&indicateur="+indic, 'A');
		});
		$(document).on("submit", "[data-submit]", function(e) {
			if ($(this).attr("action"))
				xt_form(this, 'C', xtn2, xtpage+"&indicateur="+$(this).attr("action"), 'N');
		});
	},

	cleanString: function (str) {
		var cleanStr = $.trim(
				str.replace(/(\r\n|\n|\r)/gm, ' ')
				.replace(/\s+/g, ' ')
				.replace(/[àáâãäå]/gi,"a")
				.replace(/[ç]/gi,"c")
				.replace(/[èéêë]/gi,"e")
				.replace(/[ìíîï]/gi,"i")
				.replace(/[òóôõö]/gi,"o")
				.replace(/[œ]/gi,"oe")
				.replace(/[ùúûü]/gi,"u")
				.replace(/[^\w\s]/gi, '')
			).replace(/ /g, '_');
		return cleanStr;
	}

	});

	$.fn[pluginName] = function ( options ) {
			return this.each(function () {
					if (!$.data(this, "plugin_" + pluginName)) {
							$.data(this, "plugin_" + pluginName,
							new Plugin( this, options ));
					}
			});
	};
})( jQuery, window, document );
